<script setup>
import { ref, defineProps, defineModel, onMounted } from "vue";

const globalConfiguration = defineModel();
const props = defineProps({
  subConfig: Boolean,
  globalConfig: Object,
  loading: Boolean,
  readOnlyMode: Boolean,
});
const fields = ["UpdateDeadline", "GracePeriod", "PatchingDelay"];

function updateInherit(key) {
  if (props.readOnlyMode) {
    return;
  }
  // Check if the value exists in the global configuration
  if (!globalConfiguration.value["inherit" + key]) {
    globalConfiguration.value["inherit" + key] = true;
  } else {
    globalConfiguration.value["inherit" + key] = false;
  }
  globalConfiguration.value[key] = props.globalConfig[key];
}

onMounted(() => {
  if (!props.subConfig) {
    return;
  }
  console.log("On mounted");
  fields.forEach((field) => {
    console.log("Field", field);
    console.log("Global config", globalConfiguration.value);
    const inheritKey = "inherit" + field;
    try {
      if (globalConfiguration.value[inheritKey] === false) {
        console.log("Inherit key is false", inheritKey);
        return;
      }
    } catch (error) {
      console.log("Does not exist", inheritKey);
    }

    globalConfiguration.value[inheritKey] = true;
    globalConfiguration.value[field] = props.globalConfig[field];
  });
});
</script>
<template>
  <v-row class="ml-n5 mt-n5">
    <v-col cols="12">
      <h3>Update Behaviour</h3>
    </v-col>
  </v-row>
  <v-row>
    <v-col cols="auto" v-if="props.subConfig">
      <v-sheet class="d-flex align-center justify-center" height="100%">
        <v-icon
          class=""
          @click="updateInherit('UpdateDeadline')"
          size="x-large"
          >{{
            globalConfiguration.inheritUpdateDeadline
              ? "mdi-lock-outline"
              : "mdi-lock-open-variant-outline"
          }}</v-icon
        >
      </v-sheet>
    </v-col>
    <v-col cols="6">
      <div class="font-weight-bold">Update Deadline</div>
      <div class="text-body-2 font-weight-light text-medium-emphasis">
        Number of days from release until an application is force updated
      </div>
    </v-col>
    <v-spacer></v-spacer>
    <v-col cols="4">
      <v-number-input
        :loading="props.loading"
        :disabled="globalConfiguration.inheritUpdateDeadline"
        class="pt-3"
        label="Number of days"
        variant="outlined"
        v-model="globalConfiguration.UpdateDeadline"
        persistent-placeholder
        control-variant="split"
        :min="0"
        :readonly="props.readOnlyMode"
      ></v-number-input>
    </v-col>
  </v-row>
  <v-divider></v-divider>
  <v-row class="pt-3">
    <v-col cols="auto" v-if="props.subConfig">
      <v-sheet class="d-flex align-center justify-center" height="100%">
        <v-icon class="" @click="updateInherit('GracePeriod')" size="x-large">{{
          globalConfiguration.inheritGracePeriod
            ? "mdi-lock-outline"
            : "mdi-lock-open-variant-outline"
        }}</v-icon>
      </v-sheet>
    </v-col>
    <v-col cols="6">
      <div class="font-weight-bold">Grace Period</div>
      <div class="text-body-2 font-weight-light text-medium-emphasis">
        Number of hours after deadline has passed to allow user to quit and open
        apps required to be closed. Additional notifications will be given
        during this period.
      </div>
    </v-col>
    <v-spacer></v-spacer>
    <v-col cols="4">
      <v-number-input
        :loading="props.loading"
        :disabled="globalConfiguration.inheritGracePeriod"
        class="pt-3"
        label="Number of hours"
        variant="outlined"
        v-model="globalConfiguration.GracePeriod"
        persistent-placeholder
        control-variant="split"
        :min="0"
        :readonly="props.readOnlyMode"
      ></v-number-input>
    </v-col>
  </v-row>
  <v-divider></v-divider>
  <v-row class="pt-3">
    <v-col cols="auto" v-if="props.subConfig">
      <v-sheet class="d-flex align-center justify-center" height="100%">
        <v-icon
          class=""
          @click="updateInherit('PatchingDelay')"
          size="x-large"
          >{{
            globalConfiguration.inheritPatchingDelay
              ? "mdi-lock-outline"
              : "mdi-lock-open-variant-outline"
          }}</v-icon
        >
      </v-sheet>
    </v-col>
    <v-col cols="6">
      <div class="font-weight-bold">Patching Delay</div>
      <div class="text-body-2 font-weight-light text-medium-emphasis">
        Number of days a patch is delayed from release date showing as available
      </div>
    </v-col>
    <v-spacer></v-spacer>
    <v-col cols="4">
      <v-number-input
        :loading="props.loading"
        :disabled="globalConfiguration.inheritPatchingDelay"
        class="pt-3"
        label="Number of days"
        variant="outlined"
        v-model="globalConfiguration.PatchingDelay"
        persistent-placeholder
        control-variant="split"
        :min="0"
        :readonly="props.readOnlyMode"
      ></v-number-input>
    </v-col>
  </v-row>
</template>
